
export { default as AboutUs } from "./Organisms/AboutUs"
export { default as Advantages } from "./Molecules/Advantages"
export { default as Banner } from "./Organisms/Banners"
export { default as LastSeen } from "./Organisms/LastSeen"
export { default as Reviews } from "./Organisms/Reviews"
export { default as SubscriptionBox } from "./Organisms/SubscriptionBox"
export { default as TopDestinations } from "./Organisms/TopDestinations"
export { default as TrustPilotWidget } from "./Organisms/TrustPilotWidget"